var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 901,
    height: 779,
    viewBox: "0 0 901 779",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M350.514 46.4143C412.229 48.6037 470.094 33.0658 531.756 36.4274C612.449 40.8266 714.212 8.01239 767.011 69.1206C819.683 130.082 744.142 227.967 764.574 305.884C789.775 401.993 924.799 470.518 897.309 566.025C871.314 656.337 743.738 671.211 652.668 694.671C579.988 713.394 506.495 674.732 432.267 685.823C336.608 700.116 246.382 812.054 160.19 768.258C77.3617 726.17 109.176 595.535 80.6597 507.16C55.8698 430.334 6.40832 363.448 3.53564 282.768C0.271512 191.094 -12.5673 71.4928 63.3072 19.8089C144.414 -35.439 252.439 42.935 350.514 46.4143Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBackground);
export default __webpack_public_path__ + "static/media/login-background.02c1109b6f32dcbc168050d46747f949.svg";
export { ForwardRef as ReactComponent };